import { useEffect, useRef, useState } from 'react';
// @mui
import { Box, Divider, Typography, MenuItem, Avatar, IconButton } from '@mui/material';
// components
import MenuPopover from './MenuPopover';  
import { useNavigate } from 'react-router-dom';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';

// ----------------------------------------------------------------------

export default function AccountPopover({setLoginSuccess}) {
  const anchorRef = useRef(null);

  const [open, setOpen] = useState(null);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const loggedInUser = sessionStorage.getItem("user_token");
  const foundUser = JSON.parse(loggedInUser);
  // setUserEmail();
  // foundUser.userEmail
  // form validation rules 

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);
   
    setUserName(foundUser.userName);
    setUserEmail(foundUser.userEmail);
  },[])
  
  const navigate = useNavigate();

  const handleLogout = () => {

    setLoginSuccess(false)
    navigate("/", { replace: true });
    sessionStorage.clear();
  }

  const handleMyProfile = () => {

    navigate("/MyProfile", { replace: true });
    setOpen(null);
  }

  return (
    <>
      <IconButton
        className="accountPopoverTrigger"
        ref={anchorRef}
        onClick={handleOpen}
        aria-label="Open account menu"
        aria-haspopup="menu"
        aria-expanded={Boolean(open)}
        sx={{
          p: '4px 8px 4px 4px',
          borderRadius: '12px',
          ...(open && {
            backgroundColor: 'rgba(255, 255, 255, 0.14)',
          }),
        }}
      >
        <Avatar sx={{
          bgcolor: 'var(--mvp-green-500, #10b981)',
          color: '#052e2b',
          fontWeight: 800,
          width: 36,
          height: 36,
          fontSize: '0.9rem',
        }}>{userName ? userName[0].toUpperCase() : ""}</Avatar>
        <Box className="accountPopoverIdentity">
          <Typography className="accountPopoverName" component="span" noWrap>
            {userName || 'Account'}
          </Typography>
          <Typography className="accountPopoverRole" component="span" noWrap>
            {foundUser.role_capabilities?.all_modules_access === true ? 'Super admin' : 'Vendor user'}
          </Typography>
        </Box>
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.25,
          ml: 0.75,
          width: 'min(280px, calc(100vw - 24px))',
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 1.5,
            minHeight: 42,
            gap: 1.25,
          },
        }}
      >
        <Box sx={{ px: 2.25, pt: 2, pb: 1.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.25 }}>
            <Box sx={{
              display: 'grid',
              placeItems: 'center',
              width: 28,
              height: 28,
              color: 'var(--mvp-green-500, #10b981)',
              bgcolor: 'rgba(16, 185, 129, 0.1)',
              borderRadius: 1.25,
            }}>
              <StorefrontRoundedIcon sx={{ fontSize: 17 }} />
            </Box>
            <Typography variant="overline" sx={{ color: 'text.secondary', lineHeight: 1, letterSpacing: '0.09em' }}>
              Manual Vendor Portal
            </Typography>
          </Box>
          <Typography variant="subtitle2" sx={{ color: 'var(--mvp-text, #122136)', fontWeight: 750 }} noWrap>
            {userName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {userEmail}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {/* <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} to={option.linkTo} component={RouterLink} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack> */}
        
       { foundUser.role_capabilities?.all_modules_access !== true  && <>
        <MenuItem onClick={handleMyProfile} sx={{ m: 1 }}>
          <PersonOutlineRoundedIcon fontSize="small" />
          My Profile
        </MenuItem>
        <Divider sx={{ borderStyle: 'dashed' }} />
        </>
      }

        <MenuItem onClick={handleClose} sx={{ m: 1 }}>
          <HelpOutlineRoundedIcon fontSize="small" />
          Help
        </MenuItem>
        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1, color: 'error.main' }}>
          <LogoutRoundedIcon fontSize="small" />
          Logout
        </MenuItem>
      </MenuPopover>
    </>
  );
}
